<template>
    <div class="tempAll">
        <div class="layTitle">
            <div class="title">体温单</div>
            <div>
                <el-button type="danger" size="small" @click="close">返回留观管理</el-button>
            </div>
        </div>
        <el-form :inline="true" :model="formData" class="formBox">
            <el-form-item label="姓名">
                <el-input disabled v-model.trim="formData.clientName" style="width:60%;" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="年龄">
                <el-input disabled v-model.trim="formData.clientAge" style="width:60%;" placeholder="请输入年龄"></el-input>
            </el-form-item>
            <el-form-item label="性别">
                <el-select disabled v-model="formData.clientSex" clearable placeholder="请选择性别" style="width:60%;">
                    <el-option v-for="(item, index) in sexey" :key="index" :label="item.label" :value="item.label"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="科别">
                <el-input disabled v-model.trim="formData.departmentName" style="width:60%;"></el-input>
            </el-form-item>
            <el-form-item label="床号">
                <el-input disabled v-model.trim="formData.bedNumber" style="width:60%;" placeholder="请输入床号"></el-input>
            </el-form-item>
            <el-form-item label="入院日期">
                <el-date-picker disabled v-model="formData.hospitalizedTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择入院日期" style="width:95%;"></el-date-picker>
            </el-form-item>
        </el-form>

        <div class="temp">
            <el-table :data="items" style="width: 100%" border :show-header="false">
                <el-table-column align="center" prop="date" width="90"></el-table-column>
                <el-table-column align="center" prop="a"></el-table-column>
                <el-table-column align="center" prop="b"></el-table-column>
                <el-table-column align="center" prop="c"></el-table-column>
                <el-table-column align="center" prop="d"></el-table-column>
                <el-table-column align="center" prop="e"></el-table-column>
                <el-table-column align="center" prop="f"></el-table-column>
                <el-table-column align="center" prop="k"></el-table-column>
            </el-table>
            <!-- oninput="value=value.replace(/[^0-9.]/g, '')" -->
            <el-table :data="lists" style="width: 100%" border :show-header="false">
                <el-table-column align="center" prop="date" width="90"></el-table-column>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-input @input="testSX" v-model="scope.row.a"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-input @input="testSX" v-model="scope.row.b"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-input @input="testSX" v-model="scope.row.c"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-input @input="testSX" v-model="scope.row.d"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-input @input="testSX" v-model="scope.row.e"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-input @input="testSX" v-model="scope.row.f"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-input @input="testSX" v-model="scope.row.k"></el-input>
                    </template>
                </el-table-column>
            </el-table>

            <tableList :day="day" :datas="datas"></tableList>
        </div>
        <chart :tem="tem" @getImgData="costPlan"></chart>

        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="close">取 消</el-button>
            <el-button type="primary" @click="tab">确 定</el-button>
        </div>

    </div>
</template>
<script>
import { mapState, } from 'vuex'
import chart from './chart'
import tableList from './table'
import { log } from 'util';
export default {
    name: 'temperature',
    components: {
        chart, tableList
    },
    computed: {
        ...mapState(["sexey",]),
    },
    data() {
        return {
            formData: {},
            dom: null,
            symbolSize: 10,
            code: '',
            // 通过拖动是可以实时改变这里的值的
            data: [],
            data1: [],
            plain1: true,
            plain2: true,
            option: {},
            tableHeight: 500,
            items: [
                {
                    date: '日期',
                    a: '',
                    b: '',
                    c: '',
                    d: '',
                    e: '',
                    f: '',
                    k: '',
                    value: 'temperatureDate',
                }, {
                    date: '住院天数',
                    a: '1',
                    b: '2',
                    c: '3',
                    d: '4',
                    e: '5',
                    f: '6',
                    k: '7',
                    value: 'hospitalizationDays',
                },
                {
                    date: '手术后天数',
                    a: '手术',
                    b: '手术/1',
                    c: '1/2',
                    d: '2/3',
                    e: '3/4',
                    f: '4/5',
                    k: '5/6',
                    value: "postoperativeDays",
                }
            ],
            lists: [],
            day: '',
            tem: '',
            imgUrl: '',
            datekey: '',
            allList: [],
            datas: [],
        }
    },
    // 解决切换页面多次调用路由问题
    activated() {
        this.activatedFlag = true
        if (this.activatedFlag) {
            this.init()
        }
    },
    deactivated() { this.activatedFlag = false; },
    created() {
        this.init()
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
        init() {
            this.lists = []
            this.newMonth = ['大便(次/日)', '血压(mmHg)', '体重(Kg)', '身高(cm)', '药物过敏史', '入量(ml)', '出量(ml) 尿', '左侧腋下引流量(ml)', '右侧腋下引流量(ml)',]
            this.newMonth.forEach((item, index) => {
                this.lists.push({
                    date: item,
                    // value: 'item',
                    a: '',
                    b: '',
                    c: '',
                    d: '',
                    e: '',
                    f: '',
                    k: '',
                }, )
            });
            this.lists[0].value = 'stool'
            this.lists[1].value = 'bloodPressure'
            this.lists[2].value = 'temperatureWeight'
            this.lists[3].value = 'temperatureHeight'
            this.lists[4].value = 'allergyHistory'
            this.lists[5].value = 'intake'
            this.lists[6].value = 'output'
            this.lists[7].value = 'temperatureLeft'
            this.lists[8].value = 'temperatureOffside'
            // console.log(this.$route.params);
            this.passData = this.$route.params
            this.tem = this.passData.tem
            this.formData.departmentName = '美容外科'
            if (this.passData.code == 1) {//修改
                this.formData.bedNumber = this.passData.bedNumber
                this.formData.clientName = this.passData.clientName
                this.formData.clientAge = this.passData.clientAge
                this.formData.clientSex = this.passData.clientSex
                this.formData.hospitalizedTime = this.passData.hospitalizedTime
                this.formData.code = this.passData.code
                // console.log('回显数据this.passData');
                // console.log(this.passData);
                this.getHourData()
                this.dataChange()
            } else if (this.passData.code == 0) {//新增
                // this.formData.items = []
                this.formData.bedNumber = this.passData.bedNumber
                this.formData.clientName = this.passData.clientName
                this.formData.clientAge = this.passData.clientAge
                this.formData.clientSex = this.passData.clientSex
                this.formData.hospitalizedTime = this.passData.hospitalizedTime
                this.formData.code = this.passData.code
                this.dataTrans()
            }

            // 根据入院日期生成table日期
            this.day = this.getValueDate(this.formData.hospitalizedTime)
            this.items[0].a = this.day[0]
            this.items[0].b = this.day[1]
            this.items[0].c = this.day[2]
            this.items[0].d = this.day[3]
            this.items[0].e = this.day[4]
            this.items[0].f = this.day[5]
            this.items[0].k = this.day[6]


        },
        dataTrans() {
            this.datas = []
            let title = ['呼吸', '备注']
            title.forEach(item => {
                // console.log(item);
                this.datas.push({
                    operateDay: item,
                    breatheAndRemarks1: '',
                    breatheAndRemarks2: '',
                    breatheAndRemarks3: '',
                    breatheAndRemarks4: '',
                    breatheAndRemarks5: '',
                    breatheAndRemarks6: '',
                    breatheAndRemarks7: '',
                    breatheAndRemarks8: '',
                    breatheAndRemarks9: '',
                    breatheAndRemarks10: '',
                    breatheAndRemarks11: '',
                    breatheAndRemarks12: '',
                    breatheAndRemarks13: '',
                    breatheAndRemarks14: '',
                    breatheAndRemarks15: '',
                    breatheAndRemarks16: '',
                    breatheAndRemarks17: '',
                    breatheAndRemarks18: '',
                    breatheAndRemarks19: '',
                    breatheAndRemarks20: '',
                    breatheAndRemarks21: '',
                    breatheAndRemarks22: '',
                    breatheAndRemarks23: '',
                    breatheAndRemarks24: '',
                    breatheAndRemarks25: '',
                    breatheAndRemarks26: '',
                    breatheAndRemarks27: '',
                    breatheAndRemarks28: '',
                    breatheAndRemarks29: '',
                    breatheAndRemarks30: '',
                    breatheAndRemarks31: '',
                    breatheAndRemarks32: '',
                    breatheAndRemarks33: '',
                    breatheAndRemarks34: '',
                    breatheAndRemarks35: '',
                    breatheAndRemarks36: '',
                    breatheAndRemarks37: '',
                    breatheAndRemarks38: '',
                    breatheAndRemarks39: '',
                    breatheAndRemarks40: '',
                    breatheAndRemarks41: '',
                    breatheAndRemarks42: '',
                }, )
            });
        },
        getHourData() {
            // console.log(this.day);
            this.dataTrans()
            this.datas = this.passData.breatheAndRemarksList
            this.datas[0].operateDay = '呼吸'
            this.datas[1].operateDay = '备注'
        },
        close() {
            router.push('/observation/observation')
        },
        // 获取七天住院日期
        getValueDate(val) {
            var today = new Date(val); // 获取当前日期
            var dates = []; // 存储后七天的日期
            for (var i = 0; i < 7; i++) {
                var date = new Date(today.getTime() + 24 * 60 * 60 * 1000 * (i)); // 计算后七天的日期
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                dates.push(year + '-' + month + '-' + day); // 将日期格式化为字符串并存储到数组中
            }
            // console.log(dates); // 输出后七天的日期数组
            return dates;
        },
        costPlan(val) {
            this.imgUrl = val
        },
        // base64ToFile
        base64ToFile(data) {
            // 将base64 的图片转换成file对象上传 atob将ascii码解析成binary数据
            let binary = atob(data.split(',')[1]);
            let mime = data.split(',')[0].match(/:(.*?);/)[1];
            let array = [];
            for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            let fileData = new Blob([new Uint8Array(array)], {
                type: mime,
            });
            let file = new File([fileData], `${new Date().getTime()}.png`, {
                type: mime
            });
            return file;

        },

        tab() {
            this.allList = this.lists.concat(this.items)
            // console.log(this.allList);
            this.allList.forEach(item => {
                let arr = Object.values(item)
                // console.log(arr);
                this.formData[arr[8]] = arr.splice(1, 7)
            });
            this.formData.breatheAndRemarksList = this.datas
            this.formData.createBy = Lockr.get('skinEmpId');
            console.log(this.formData);
            // console.log('this.passData');
            // console.log(this.passData);
            if (this.passData.code == 0) {//提交新增
                this.formData.leaveObserveId = this.passData.id;
                // console.log('this.formData');
                // console.log(this.formData);
                let file = this.base64ToFile(this.imgUrl)
                var formData = new FormData();
                formData.append("file", file)
                formData.append("temperatureSheetList", JSON.stringify(this.formData))
                api.requestQuiet("/leaveObserve/createTemperatureSheet", formData, (res) => {
                    if (res.result == true) {
                        _g.toast("success", '体温单提交成功');
                        router.push({ path: '/observation/observation', query: { code: 0 }, })
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            } else if (this.passData.code == 1) {//修改
                console.log(this.passData);
                console.log(this.passData.leaveObserveId);
                this.formData.leaveObserveId = this.passData.leaveObserveId;
                let file = this.base64ToFile(this.imgUrl)
                var formData = new FormData();
                formData.append("file", file)
                formData.append("temperatureSheetList", JSON.stringify(this.formData))
                api.requestQuiet("/leaveObserve/updateTemperatureSheet", formData, (res) => {
                    if (res.result == true) {
                        _g.toast("success", '体温单修改成功');
                        router.push({ path: '/observation/observation', query: { code: 0 }, })
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            }
        },
        dataChange() {
            let arr = [
                {
                    date: '大便(次/日)',
                    a: this.passData.stool[0],
                    b: this.passData.stool[1],
                    c: this.passData.stool[2],
                    d: this.passData.stool[3],
                    e: this.passData.stool[4],
                    f: this.passData.stool[5],
                    k: this.passData.stool[6],
                    value: 'stool',
                },
                {
                    date: '血压(mmHg)',
                    a: this.passData.bloodPressure[0],
                    b: this.passData.bloodPressure[1],
                    c: this.passData.bloodPressure[2],
                    d: this.passData.bloodPressure[3],
                    e: this.passData.bloodPressure[4],
                    f: this.passData.bloodPressure[5],
                    k: this.passData.bloodPressure[6],
                    value: 'bloodPressure',
                },
                {
                    date: '体重(Kg)',
                    a: this.passData.temperatureWeight[0],
                    b: this.passData.temperatureWeight[1],
                    c: this.passData.temperatureWeight[2],
                    d: this.passData.temperatureWeight[3],
                    e: this.passData.temperatureWeight[4],
                    f: this.passData.temperatureWeight[5],
                    k: this.passData.temperatureWeight[6],
                    value: 'temperatureWeight',
                },
                {
                    date: '身高(cm)',
                    a: this.passData.temperatureHeight[0],
                    b: this.passData.temperatureHeight[1],
                    c: this.passData.temperatureHeight[2],
                    d: this.passData.temperatureHeight[3],
                    e: this.passData.temperatureHeight[4],
                    f: this.passData.temperatureHeight[5],
                    k: this.passData.temperatureHeight[6],
                    value: 'temperatureHeight',
                },
                {
                    date: '药物过敏史',
                    a: this.passData.allergyHistory[0],
                    b: this.passData.allergyHistory[1],
                    c: this.passData.allergyHistory[2],
                    d: this.passData.allergyHistory[3],
                    e: this.passData.allergyHistory[4],
                    f: this.passData.allergyHistory[5],
                    k: this.passData.allergyHistory[6],
                    value: 'allergyHistory',
                },
                {
                    date: '入量(ml)',
                    a: this.passData.intake[0],
                    b: this.passData.intake[1],
                    c: this.passData.intake[2],
                    d: this.passData.intake[3],
                    e: this.passData.intake[4],
                    f: this.passData.intake[5],
                    k: this.passData.intake[6],
                    value: 'intake',
                },
                {
                    date: '出量(ml)',
                    a: this.passData.output[0],
                    b: this.passData.output[1],
                    c: this.passData.output[2],
                    d: this.passData.output[3],
                    e: this.passData.output[4],
                    f: this.passData.output[5],
                    k: this.passData.output[6],
                    value: 'output',
                },
                {
                    date: '左侧腋下引流量(ml)',
                    a: this.passData.temperatureLeft[0],
                    b: this.passData.temperatureLeft[1],
                    c: this.passData.temperatureLeft[2],
                    d: this.passData.temperatureLeft[3],
                    e: this.passData.temperatureLeft[4],
                    f: this.passData.temperatureLeft[5],
                    k: this.passData.temperatureLeft[6],
                    value: 'temperatureLeft',
                },
                {
                    date: '右侧腋下引流量(ml)',
                    a: this.passData.temperatureOffside[0],
                    b: this.passData.temperatureOffside[1],
                    c: this.passData.temperatureOffside[2],
                    d: this.passData.temperatureOffside[3],
                    e: this.passData.temperatureOffside[4],
                    f: this.passData.temperatureOffside[5],
                    k: this.passData.temperatureOffside[6],
                    value: 'temperatureOffside',
                },
            ]
            this.lists = arr
        }
    }
}
</script>
<style scoped>
.temp >>> .el-table td,
.el-table th {
  padding: 0 !important;
  box-sizing: border-box;
}
.temp >>> .el-table th {
  padding: 0 !important;
  box-sizing: border-box;
}
.temp >>> .el-input__inner {
  height: 30px !important;
  line-height: 30px;
  padding: 0 !important;
  box-sizing: border-box;
  border: none;
  text-align: center;
}
.temp >>> .cell {
  padding: 0 !important;
}
.temp >>> .el-select__tags {
  overflow: scroll;
  flex-wrap: nowrap;
  max-width: 200px !important;
}
.layTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.partFooter {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
</style>


